import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout";
import styles from "./Dashboard.module.css";
import { ImUser } from "react-icons/im";
import { FaSearch, FaFilter } from "react-icons/fa";
import {
    searchCompanies,
    getPurchasedCompaniesByUser,
    create_companies,
    getTeamsByUserId,
    getExpiredPurchasedCompaniesByUser,
} from "../../Services/APIrequests";
import { useNavigate } from "react-router-dom";
import useStore from "../../Store";

const Dashboard = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [teams, setTeams] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const [purchasedCompanies, setPurchasedCompanies] = useState([]);
    const [userHistory, setUserHistory] = useState([]); // instead of history
    const [expiredCompanies, setExpiredCompanies] = useState([]);
    const [visibleCompanies, setVisibleCompanies] = useState(6);
    const navigate = useNavigate();
    const { setCIN } = useStore();
    const fetchCompanyData = async (cin) => {
        setLoading(true);
        setError(null);

        try {
            const params = new URLSearchParams();
            params.append("aboutTheCompany", "true");
            /* if (status === 1) {
            } else if (status === 2) {
                params.append("directors", "true");
            } */

            const res = await create_companies(cin, params);
            if (res.status === 200) {
                navigate(`/kohere/Companydetails/${cin}`);
            } else {
                setError("Failed to fetch company data");
            }
        } catch (err) {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        // Adjust visible companies based on screen width
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setVisibleCompanies(2); // For mobile, show only 2 companies
            } else {
                setVisibleCompanies(6); // For desktop, show 6 companies
            }
        };

        // Listen for window resize
        window.addEventListener("resize", handleResize);

        // Call once on initial load to set the correct number of visible companies
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [purchasedCompanies.length]);

    const handleButtonClick = (index) => {
        setActiveTab(index);
    };

    // Fetch teams by user
    useEffect(() => {
        const fetchTeams = async () => {
            try {
                const response = await getTeamsByUserId();
                if (response.data.success) {
                    setTeams(response.data.teams || []);
                }
            } catch (error) {
                console.error("Failed to fetch teams:", error);
            }
        };
        fetchTeams();
    }, []);

    // Fetch purchased companies by user
    useEffect(() => {
        const fetchPurchasedCompanies = async () => {
            const token = sessionStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }
            try {
                const response = await getPurchasedCompaniesByUser(token);

                // Set purchased companies
                const purchasedCompanies =
                    response.data.purchasedCompanies || [];
                setPurchasedCompanies(purchasedCompanies);

                // Set recent visits / history
                const historyData = response.data.history || [];
                setUserHistory(historyData);
            } catch (error) {
                console.error("Error fetching purchased companies:", error);
            }
        };
        fetchPurchasedCompanies();
    }, [navigate]);

    // Fetch expired purchased companies by user
    useEffect(() => {
        const fetchExpiredCompanies = async () => {
            const token = sessionStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }
            try {
                const response = await getExpiredPurchasedCompaniesByUser(
                    token
                );
                const expiredCompanies = response.data.expiredCompanies || [];
                setExpiredCompanies(expiredCompanies);
            } catch (error) {
                console.error(
                    "Error fetching expired purchased companies:",
                    error
                );
            }
        };
        fetchExpiredCompanies();
    }, [navigate]);

    // Function to fetch company data by CIN

    // Function to handle "Show more" click for recent visits
    const handleShowMore = () => {
        navigate("/kohere/myhistory");
    };
    const handleCompanyClick = (cin) => {
        setCIN(cin);
        fetchCompanyData(cin);
    };
    return (
        <Layout Active={"Dashboard"}>
            <div className={styles.Dashboard_container}>
                <div className={styles.sub_container}>
                    <div className={styles.vtext_container}>
                        <p className={styles.vheadertext}>RECENT VISITS</p>
                        <div className={styles.vbodytext}>
                            {userHistory.length > 0
                                ? userHistory
                                      .slice(0, visibleCompanies)
                                      .map((company, index) => (
                                          <React.Fragment key={company.CIN}>
                                              <p
                                                  onClick={() =>
                                                      handleCompanyClick(
                                                          company.CIN
                                                      )
                                                  }>
                                                  <span
                                                      className={
                                                          styles.clickableCompany
                                                      }>
                                                      {company.companyName}
                                                  </span>
                                              </p>
                                              {/* Add a line break after every 4th company */}
                                              {index % 4 === 3 && <br />}
                                          </React.Fragment>
                                      ))
                                : "No recent visits."}

                            {/* Show the 'See All' button if there are more companies to show */}
                            {userHistory.length > visibleCompanies && (
                                <button
                                    className={styles.showMoreButton}
                                    onClick={handleShowMore}>
                                    ...See All
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Existing table for purchased companies */}
                    <div className={styles.table_container}>
                        <div className={styles.buttton_container}>
                            <div className={styles.status_btns}>
                                <button
                                    className={`order_statusbuttons ${
                                        activeTab === 0 ? "active" : ""
                                    }`}
                                    onClick={() => handleButtonClick(0)}
                                    type="button">
                                    <ImUser size={20} />
                                    My list
                                </button>
                            </div>
                        </div>

                        <table className={styles.commantable}>
                            <thead className={styles.table_header}>
                                <tr className={styles.tableHeaderRow}>
                                    <th className={styles.tableHeader}>
                                        Company Name
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Date Unlocked
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Valid Till Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchasedCompanies.length > 0 ? (
                                    purchasedCompanies.map((company, index) => (
                                        <tr
                                            key={index}
                                            onClick={() =>
                                                handleCompanyClick(
                                                    company.CompanyID
                                                )
                                            }>
                                            <td>{company.CompanyName}</td>
                                            <td>
                                                {new Date(
                                                    company.DateOfPurchase
                                                ).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })}
                                            </td>
                                            <td>
                                                {new Date(
                                                    company.ValidUpto
                                                ).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">
                                            No purchased companies
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* New table for expired purchased companies */}
                    <div className={styles.table_container}>
                        <h3 className={styles.Expiredtable_container}>
                            Expired Purchased Companies
                        </h3>
                        <table className={styles.commantable}>
                            <thead className={styles.table_header}>
                                <tr className={styles.tableHeaderRow}>
                                    <th className={styles.tableHeader}>
                                        Company Name
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Date Unlocked
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Valid Till Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {expiredCompanies.length > 0 ? (
                                    expiredCompanies.map((company, index) => (
                                        <tr
                                            key={index}
                                            onClick={() =>
                                                handleCompanyClick(
                                                    company.CompanyID
                                                )
                                            }>
                                            <td>{company.CompanyName}</td>
                                            <td>
                                                {new Date(
                                                    company.DateOfPurchase
                                                ).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })}
                                            </td>
                                            <td>
                                                {new Date(
                                                    company.ValidUpto
                                                ).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">
                                            No expired companies
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Dashboard;
